"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../container/ServiceIdentifiers");
const ILevelledTopologicalSorter_1 = require("../interfaces/utils/ILevelledTopologicalSorter");
let NodeTransformerNamesGroupsBuilder = class NodeTransformerNamesGroupsBuilder {
    constructor(levelledTopologicalSorter) {
        this.levelledTopologicalSorter = levelledTopologicalSorter;
    }
    build(normalizedNodeTransformers) {
        const nodeTransformerNames = Object.keys(normalizedNodeTransformers);
        const relationEdges = this.buildNodeTransformersRelationEdges(nodeTransformerNames, normalizedNodeTransformers);
        for (const [precedent, consequent] of relationEdges) {
            this.levelledTopologicalSorter.add(precedent, consequent);
        }
        return this.levelledTopologicalSorter.sortByGroups();
    }
    buildNodeTransformersRelationEdges(nodeTransformerNames, normalizedNodeTransformers) {
        const relationEdges = [];
        for (const nodeTransformerName of nodeTransformerNames) {
            const nodeTransformer = normalizedNodeTransformers[nodeTransformerName];
            const runAfterRelations = nodeTransformer.runAfter;
            if (!runAfterRelations || !runAfterRelations.length) {
                relationEdges.push([nodeTransformerName, null]);
                continue;
            }
            for (const runAfterRelation of runAfterRelations) {
                const isUnknownRelation = normalizedNodeTransformers[runAfterRelation] === undefined;
                if (isUnknownRelation) {
                    relationEdges.push([nodeTransformerName, null]);
                    continue;
                }
                relationEdges.push([runAfterRelation, nodeTransformerName]);
            }
        }
        return relationEdges;
    }
};
NodeTransformerNamesGroupsBuilder = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.ILevelledTopologicalSorter)),
    __metadata("design:paramtypes", [typeof (_a = typeof ILevelledTopologicalSorter_1.ILevelledTopologicalSorter !== "undefined" && ILevelledTopologicalSorter_1.ILevelledTopologicalSorter) === "function" ? _a : Object])
], NodeTransformerNamesGroupsBuilder);
exports.NodeTransformerNamesGroupsBuilder = NodeTransformerNamesGroupsBuilder;
